export default "__VITE_ASSET__BOGH7fYj__"